var _ellipse, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOneClick2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 134,
    viewBox: "0 0 268 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_320_650",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 19,
    width: 229,
    height: 229
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.965,
    cy: 133.966,
    rx: 113.992,
    ry: 113.992,
    transform: "rotate(-78.7982 133.965 133.966)",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_320_650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.90468 652.646C97.3114 403.932 54.7561 108.474 -119.681 -56.3351",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2477 655.302C108.464 406.588 95.2312 171.738 -108.528 -53.6788",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3873 657.007C121.603 408.293 107.498 168.778 -95.3884 -51.9742",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1818 660.439C142.102 372.824 91.8426 116.267 -82.594 -48.5421",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6076 663.691C150.824 414.977 108.268 119.52 -66.1682 -45.2896",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9826 665.746C156.281 421.448 128.914 160.441 -55.7933 -43.2354",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9474 668.312C174.164 419.598 143.333 201.027 -42.8283 -40.669",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2208 669.847C196.049 431.571 141.193 166.468 -30.555 -39.1344",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.702 669.821C192.694 394.073 170.064 170.388 -17.074 -39.1602",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.671 672.388C212.887 423.674 173.58 154.912 -4.10471 -36.5933",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.166 690.707C300.444 389.808 276.641 185.655 88.3903 -18.274",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.771 674.784C224.987 426.07 182.432 130.612 7.99538 -34.1968",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.27 693.103C303.172 414.603 297.715 179.047 100.494 -15.878",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.468 677.695C239.684 428.981 197.129 133.523 22.6922 -31.2862",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.964 696.012C317.473 392.28 306.743 201.496 115.189 -12.9688",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.433 680.263C252.649 431.549 238.329 215.799 35.6575 -28.7178",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.934 698.583C316.276 398.334 340.151 227.879 128.158 -10.398",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.4 682.83C265.616 434.116 252.075 218.97 48.6243 -26.1505",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.899 701.15C332.896 414.202 342.04 222.863 141.123 -7.83064",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.828 686.085C280.033 379.477 251.595 191.924 65.0521 -22.896",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.325 704.402C342.676 421.528 333.41 182.522 157.549 -4.57917",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.201 688.138C302.384 409.506 245.839 164.281 75.4251 -20.8428",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.699 706.456C346.051 331.909 320.954 175.114 167.924 -2.52497",
    stroke: "white",
    strokeOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneClick2);
export default __webpack_public_path__ + "static/media/one-click-2.b92f9745b3ec2ab010d4e7116f94322c.svg";
export { ForwardRef as ReactComponent };